import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { ICitationsByVehicleAge, VehiclesChartsData } from '../models/vehicle.models';
import { environment } from '../../environments/environment';
import { IFilters } from 'app/models/filter.models';
import { CitationChartsService } from './citation-charts.service';
import { CitationCharts } from 'app/models/citation-charts.models';
import { ISelectionsDTO } from 'app/models/chart.models';
import { OLDER_VEHICLE_THRESHOLD } from 'app/constants/vehicle.contstant';

@Injectable({
  providedIn: 'root',
})
export class VehicleService {
  constructor(
    private http: HttpClient,
    private chartsService: CitationChartsService,
  ) {}

  getCombinedVehiclesData(selections: ISelectionsDTO, filters?: IFilters): Observable<VehiclesChartsData> {
    const commonObservable = this.chartsService.getVehiclesCharts(selections, filters);
    const byAgeObservable = selections
      ? this.http.post<ICitationsByVehicleAge>(`${environment.apiUrl}/api/analytics/charts/citations-by-vehicle-age`, {
          selections,
          filters,
          thresholdYear: OLDER_VEHICLE_THRESHOLD,
        })
      : of({ name: '', values: [] });
    const makesObservable = this.chartsService.getVehiclesMakes(selections, filters);
    return forkJoin([commonObservable, byAgeObservable, makesObservable]).pipe(
      catchError(() => {
        return of([]);
      }),
      map(([common, byAge, makes]) => {
        const vehicleColors = common?.find((v) => v.name === CitationCharts.VEHICLE_COLOR)?.values ?? [];
        const vehicleTypes = common?.find((v) => v.name === CitationCharts.VEHICLE_TYPE)?.values ?? [];
        const vehicleMakes = makes?.find((v) => v.name === CitationCharts.VEHICLE_MAKE)?.values ?? [];
        const citationsByVehicleAge = byAge ?? { name: '', values: [] };
        return {
          vehicleColors,
          vehicleTypes,
          vehicleMakes,
          citationsByVehicleAge,
        };
      }),
    );
  }
}
